import React, { useState } from 'react';

const MultiplicationVisual: React.FC = () => {
    const [currentQuestion, setCurrentQuestion] = useState(generateQuestion());
    const [answerFeedback, setAnswerFeedback] = useState<string | null>(null);
    const [selectedOption, setSelectedOption] = useState<number | null>(null);
    const [showImage, setShowImage] = useState(false);


    document.title = "Mamas Guidance - Class Two - Mathematics - Multiplication - Visual Problem"; // Set page title

    // Function to generate a random question and options
    function generateQuestion() {
        const num1 = Math.floor(Math.random() * 90) + 10; // Random number from 1 to 9
        const num2 = Math.floor(Math.random() * 9) + 2; // Random number from 1 to 9
        const correctAnswer = num1 * num2;

        // Generate options
        const options = new Set<number>();
        options.add(correctAnswer); // Ensure correct answer is included
        // while (options.size < 3) {
        //     options.add(Math.floor(Math.random() * (num1 * num2)) + 1); // Random number up to 9x9
        // }
        options.add(correctAnswer + 10); 
        options.add(correctAnswer - 10); 

        return {
            num1,
            num2,
            correctAnswer,
            options: Array.from(options).sort(() => Math.random() - 0.5), // Shuffle options
        };
    }

    // Handle answer selection
    const handleAnswer = (selectedAnswer: number) => {
        if (selectedAnswer === currentQuestion.correctAnswer) {
            setShowImage(true)
        }
        setSelectedOption(selectedAnswer);

        setTimeout(() => {
            if (selectedAnswer === currentQuestion.correctAnswer) {
                setCurrentQuestion(generateQuestion()); // Generate next question
                setShowImage(false);
            }
        }, 5000);
    };

    return (
        <>
            {
                showImage === false ?
                <>
                    <div className='contentPart'>
                        <div className="questionArea">
                            <div className='grid-container'>
                                <div className='grid-box text-right'>
                                    <div className="number-row" style={{opacity:'0'}}>x</div>
                                    <div className="number-row">x</div>
                                </div>
                                <div className='grid-box text-left'>
                                    <div className="number-row">{currentQuestion.num1}</div>
                                    <div className="number-row">&nbsp;&nbsp;{currentQuestion.num2}</div>
                                </div>
                            </div>
                            <div className='dividerClass'>
                                <hr className="divider" />
                            </div>
                            <div className='text-center'>
                                <div className="optionDiv">
                                    {/* <div className='middle-grid'> */}
                                    {currentQuestion.options.map((option, index) => (
                                        <div
                                            key={index}
                                            className={`background-blue ${selectedOption === option
                                                ? option === currentQuestion.correctAnswer
                                                    ? 'correct'
                                                    : 'incorrect'
                                                : ''
                                                }`}
                                            onClick={() => handleAnswer(option)}
                                        >
                                            {option}
                                        </div>
                                    ))}
                                    {/* </div> */}
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </>
                :
                <>
                    <div className="contentPart showMiddle">
                        <img style={{height: '150px'}} className='img-fluid' src={process.env.REACT_APP_WELDONE_LINK} />
                    </div>
                </>
            }
        </>
    );
};

export default MultiplicationVisual;
